/*
 * 共通：画面内に入った要素に is-visible を付与（スクロール表示アニメ用）
 * 対象: class="js-reveal"
 * 任意: data-reveal-threshold="0.05" で発火しきい値を個別指定（既定 0.4）
 *       （セクション単位で早めに発火させたい場合などに使用）
 */
(function () {
  function init(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.js-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // しきい値 + rootMargin ごとに observer を分ける
    var groups = {};
    els.forEach(function (el) {
      var t = parseFloat(el.getAttribute('data-reveal-threshold'));
      if (isNaN(t)) t = 0.4;
      var margin = el.getAttribute('data-reveal-margin') || '0px';
      var key = t + '|' + margin;
      (groups[key] = groups[key] || { threshold: t, margin: margin, items: [] }).items.push(el);
    });

    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: group.threshold, rootMargin: group.margin }
      );

      group.items.forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // テーマエディタでセクションを追加 / 再描画したとき
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
